import PropTypes from 'prop-types';
import React from 'react';
import { toLower } from 'lodash';
var SIMPLE_PRODUCT_TYPE_LOOKUP = {
  // confirmed values
  digital_audio_full_length_digital: 'Album',
  digital_audio_ep_digital: 'EP',
  digital_audio_single_digital: 'Single',
  digital_audio_single: 'Single',
  digital_audio_full_length: 'Album',
  physical_audio_12_vinyl_album: '12" Album',
  physical_audio_cd_album: 'CD Album',
  music_video_full_length: 'Music Video',
  music_video_full_length_music_video: 'Music Video',
  // physical_audio: '', // this isn't defined in doc?
  // probable values based off confirmed values
  physical_audio_12_vinyl_ep: '12" EP',
  physical_audio_12_vinyl_single: '12" Single',
  physical_audio_10_vinyl_ep: '10" EP',
  physical_audio_10_vinyl_single: '12" Single',
  physical_audio_10_vinyl_album: '10" Album',
  physical_audio_7_vinyl_ep: '7" EP',
  physical_audio_7_vinyl_single: '7" Single',
  digital_audio_ep: 'EP',
  physical_audio_cassette_ep: 'Cassette EP',
  physical_audio_cassette_single: 'Cassette Single',
  physical_audio_cassette_album: 'Cassette Album',
  physical_audio_cd_ep: 'CD EP',
  physical_audio_cd_single: 'CD Single',
  // guessed from spreadsheet
  music_video_lyrics: 'Lyrics Music Video',
  music_video_psuedo: 'Pseudo Video',
  // spelled incorrectly in doc. left in just in case
  music_video_pseudo: 'Pseudo Video',
  music_video_promo: 'Promo',
  music_video_live: 'Live',
  music_video_other: 'Other' // no idea
  // 'Behind The Scenes'

};

var simplifyProductType = function simplifyProductType(productConfiguration, format, configuration) {
  var key = "".concat(toLower(productConfiguration), "_").concat(toLower(format), "_").concat(toLower(configuration));
  key = key.replace(/[^a-z0-9]/g, '_'); // remove non-alphanumerics

  key = key.replace(/\d_x_/, '_'); // remove #_x_

  key = key.replace(/_{2,}/g, '_'); // trim down any blocks of _

  key = key.replace(/^_|_$/g, ''); // remove any preceding/trailing _

  var productType = SIMPLE_PRODUCT_TYPE_LOOKUP[key];
  if (productType) return productType;
  return false;
};

var ProductDisplayType = function ProductDisplayType(_ref) {
  var typeOfVideo = _ref.typeOfVideo,
      productConfiguration = _ref.productConfiguration,
      format = _ref.format,
      configuration = _ref.configuration;
  return React.createElement("span", null, typeOfVideo || (simplifyProductType(productConfiguration, format, configuration) ? simplifyProductType(productConfiguration, format, configuration) : format) || 'Video');
};

ProductDisplayType.propTypes = {
  productConfiguration: PropTypes.string,
  format: PropTypes.string,
  typeOfVideo: PropTypes.string,
  configuration: PropTypes.string
};
export default ProductDisplayType;